import { SubAreaContent } from "../contentManager/SubAreaContent";
import { Area } from "../dataTypes/generated";

export const CommunicationContent = ({ area }: { area: Area }) => {
    return <SubAreaContent notes={true} area={area} isProjectSpecific={true} />
};